import {Notifier} from '@airbrake/browser';
import Vue from 'vue'

let airbrake = {};

// _AutofillCallbackHandler seems to be only happening inside the Instagram-browser
// https://stackoverflow.com/questions/72720387/cant-find-variable-autofillcallbackhandler
// Doesn't affect the user
//
// gCrWeb is a iOS Chrome only thing, it's injected by Chrome, so not
// our problem if it doesn't exist
//
const excludeMessages =  [
  /Blocked a frame with origin/,
  /_AutofillCallbackHandler/,
  /__gCrWeb/,
  /(chrome|safari)-extension:\/\//i
];

if (process.env.NODE_ENV && process.env.NODE_ENV != 'development') {
  airbrake = new Notifier({
    projectId: 115016,
    projectKey: 'ce619e109bc257c1b4922bb9141cd26e',
    environment: process.env.NODE_ENV
  })

  airbrake.addFilter((notice) => {
    const error = notice.errors[0]

    let matches = excludeMessages.filter(function(excludeMessage) {
      return error.message.match(excludeMessage);
    });

    if(matches.length > 0)
      return null;

    // Ignore all abort errors since those are caused by user actions
    if (error.name == "AbortError" || error.type == "AbortError")
      return null

    // Let's get rid of some known issue makers which are out of our control
    const backtrace = error.backtrace

    // Ignore all errors that originate from GTM or browser extensions, since we have no control over them
    for (let i=0; i<backtrace.length; i++) {
      if (/gtm.js|(chrome|safari)-extension:/.test(backtrace[i].file)) {
        return null;
      }
    }

    return notice
  })

  Vue.config.errorHandler = function (err, vm, info) {
    airbrake.notify({
      error: err,
      params: {info: info}
    });
  }
}

export default airbrake
